import * as React from "react";
import axios, { AxiosResponse } from "axios";
import { Rules, RuleSettingMap, RuleListSetting } from "../types";
import { useRulesDispatch } from ".";

export function useActions() {
  const dispatch = useRulesDispatch();

  const getRules = React.useCallback(async function getRules() {
    dispatch({ type: "LOAD_RULES" });
    try {
      const request: AxiosResponse<Rules> = await axios.get("/rules");

      if (request.status === 200) {
        // * format rules to match expected config shape
        const formatted: RuleListSetting[] = Array.from(
          Object.values(request.data)
        ).map((rule) => ({
          priority: 0,
          filterable: rule.name,
          rule: {
            id: rule.id,
            name: rule.name,
          },
        }));

        const rules: RuleSettingMap = new Map(
          formatted.map((rule) => [rule.rule.id, rule])
        );
        dispatch({ type: "LOAD_RULES_SUCCESS", rules, ruleList: formatted });
      } else {
        dispatch({ type: "LOAD_RULES_FAIL", error: request.statusText });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: "LOAD_RULES_FAIL", error });
    }
  }, []);

  return {
    getRules,
  };
}
